import React from 'react'
import { Text,Document, StyleSheet,} from "@react-pdf/renderer";
// Font.register({ family: 'courier', src: source });
export const styles = StyleSheet.create({
    // page: { backgroundColor: 'tomato' },
    // section: { color: 'white', textAlign: 'center', margin: 30 }
    document:{padding:35,paddingTop:25},
    header0:{
        textAlign:"right",
        fontSize:"12pt",
        fontFamily:"Helvetica",
        marginBottom:10
    },
    header1:{
            height: 50,
            width: 70,
    },
    header2:{
        textAlign:"right",
        fontFamily:"Helvetica-Bold",
        fontSize:"14",
        marginRight:70,
    },
    headerContainer:{
        display:"flex",
        flexDirection:"row",
        paddingBottom:15,
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderRightWidth:0
    },
    page1Content:{
        marginTop:15,
        display:"flex",
        flexDirection:"row",
        fontSize:11,
        fontFamily:"Helvetica"
    },
    page1LeftContent:{
        marginRight:12
    },
    page1RightContent:{
        
    },
    dot:{
        // height:3,
        // width:3,
        // backgroundColor:"black",
        // borderTopLeftRadius:5,
        // borderTopRightRadius:5,
        // borderBottomRightRadius:5,
        // borderBottomLeftRadius:5,
        marginRight:10
    },
    dotLine:{
        display:"flex",
        flexDirection:"column",
        textAlign:"left"
    },
    page2Header:{
        display:"flex",
        flexDirection:"row",
    },
    page2HeaderLine:{
        textAlign:"right",
        fontFamily:"Helvetica",
        fontSize:"11",
        marginRight:70,
    },
    page2HeaderBox:{
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 2,
        marginTop:6,
        fontSize:10,
        textAlign:"center",
        backgroundColor:"#DCDCDC",
        fontFamily:"Helvetica-Bold",
        marginBottom:3
    },
    nameInfo:{
        display:"flex",
        flexDirection:"column",
        marginRight:40,
        fontSize:10,
        marginLeft:20
    },
    nameInfo1:{
        display:"flex",
        flexDirection:"column",
        marginRight:20,
        fontSize:10,
        marginLeft:20
    },
    nameInfoContainer:{
        display:"flex",
        flexDirection:"row",
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1.5,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderRightWidth:0,
        borderBottomWidth:1.5
    },
    prefixContainer:{
        display:"flex",
        flexDirection:"row",
        borderWidth: 1.5,
        borderLeftWidth: 1.5,
        borderTopWidth: 0,
        borderRightWidth:0,
        borderBottomWidth:0
    },
    prefixElement:{
        display:"flex",
        flexDirection:"row",
        fontSize:10
        // marginRight:15
    },
    dateContainer:{
        display:"flex",
        flexDirection:"row",
        fontSize:10,
        borderWidth: 2,
        borderLeftWidth: 0,
         borderTopWidth: 0,
         borderRightWidth:0,
        borderBottomWidth:2,
    },
    birthDt:{
        fontSize:10,
        marginLeft:20,
        marginBottom:0,
        marginTop:4
    },
    birthDtCnt:{
       display:"flex",
       flexDirection:"row",
       borderWidth: 1.5,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderRightWidth:2,
        borderBottomWidth:0,
        fontSize:10
    },
    sexCnt:{
        display:"flex",
        flexDirection:"column",
        borderWidth: 1.5,
         borderLeftWidth: 0,
         borderTopWidth: 0,
         borderRightWidth:2,
         borderBottomWidth:0,
         fontSize:10,
         marginBottom:0
     },
     sexCnt1:{
        display:"flex",
        flexDirection:"column",
        borderWidth: 1.5,
         borderLeftWidth: 0,
         borderTopWidth: 0,
         borderRightWidth:0,
         borderBottomWidth:0,
         fontSize:10,
         marginBottom:0
     },
     page2Para:{
        fontSize:9.2,
        marginLeft:20,
     },
     page2paraCnt:{
        fontSize:11,
        borderWidth: 2,
         borderLeftWidth: 0,
         borderTopWidth: 0,
         borderRightWidth:0,
         borderBottomWidth:2,
         marginTop:3,
         marginBottom:3
     },
     underLine:{
        borderWidth: 2,
         borderLeftWidth: 0,
         borderTopWidth: 0,
         borderRightWidth:0,
         borderBottomWidth:1.4,
     },
     alligner:{
        marginLeft:20,
        fontSize:11
     },
     verticalLine:{
        borderWidth: 2,
         borderLeftWidth: 0,
         borderTopWidth: 0,
         borderRightWidth:1.2,
         borderBottomWidth:0,
         marginLeft:6,
         marginRight:6
     },
     page3Container:{
        fontSize:12,
        fontFamily:"Times-Roman",
        borderWidth: 1.3,
    }
  });